import FoundedYearCard from "components/company/v2/cards/FoundedYearCard";
import IconCard, { CardDescription, CardValue } from "components/company/v2/cards/IconCard";
import IndexParticipationCard from "components/company/v2/cards/IndexParticipationCard";
import MarketCapCard from "components/company/v2/cards/MarketCapCard";
import useBrazilianRealEstateFundIssuer from "components/company/v3/context/hooks/useBrazilianRealEstateFundIssuer";
import { tailwindColors } from "components/ui/colors/colorsBundle";
import format from "date-fns/format";
import parseDateYmd from "lib/utils/parseDateYmd";
import { BanIcon, CrosshairIcon, CrownIcon, LayersIcon, TableRowsSplitIcon, UserIcon } from "lucide-react";
import { FormattedMessage } from "react-intl";

export default function FiisCardsContent() {
  const issuer = useBrazilianRealEstateFundIssuer();

  const deadline = issuer.dateOfDuration ? format(parseDateYmd(issuer.dateOfDuration), "dd/MM/yyyy") : "Indeterminado";

  return (
    <div className="grid grid-cols-1 items-center gap-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      <MarketCapCard issuer={issuer} />

      <FoundedYearCard issuer={issuer} />
      <IndexParticipationCard issuer={issuer} />

      <IconCard
        primaryColor={tailwindColors.red[400]}
        secondaryColor={tailwindColors.red[100]}
        icon={<BanIcon size={14} strokeWidth={1.5} absoluteStrokeWidth={true} />}
      >
        <CardValue title={deadline}>{deadline}</CardValue>
        <CardDescription>
          <FormattedMessage
            defaultMessage="Prazo"
            id="CROMAZ"
            description="Conteúdo dos cards para ativos do tipo FIIs"
          />
        </CardDescription>
      </IconCard>

      <IconCard
        primaryColor={tailwindColors.emerald[400]}
        secondaryColor={tailwindColors.emerald[100]}
        icon={<CrosshairIcon size={14} strokeWidth={1.5} absoluteStrokeWidth={true} />}
      >
        <CardValue title={issuer.audience}>{issuer.audience}</CardValue>
        <CardDescription>
          <FormattedMessage
            defaultMessage="Público-Alvo"
            id="6IX8lr"
            description="Conteúdo dos cards para ativos do tipo FIIs"
          />
        </CardDescription>
      </IconCard>

      <IconCard
        primaryColor={tailwindColors.indigo[400]}
        secondaryColor={tailwindColors.indigo[100]}
        icon={<TableRowsSplitIcon size={14} strokeWidth={1.5} absoluteStrokeWidth={true} />}
      >
        <CardValue title={issuer.selfRegulation.primarySegment}>{issuer.selfRegulation.primarySegment}</CardValue>
        <CardDescription>
          <FormattedMessage
            defaultMessage="Segmento"
            id="n1l1RO"
            description="Conteúdo dos cards para ativos do tipo FIIs"
          />
        </CardDescription>
      </IconCard>

      {issuer.classification.length > 0 && (
        <IconCard
          primaryColor={tailwindColors.purple[400]}
          secondaryColor={tailwindColors.purple[100]}
          icon={<LayersIcon size={14} strokeWidth={1.5} absoluteStrokeWidth={true} />}
        >
          <CardValue title={issuer.classification.join(" / ")}>{issuer.classification.join(" / ")}</CardValue>
          <CardDescription>
            <FormattedMessage
              defaultMessage="Tipo"
              id="wWPwjP"
              description="Conteúdo dos cards para ativos do tipo FIIs"
            />
          </CardDescription>
        </IconCard>
      )}

      {issuer.selfRegulation.mandate && (
        <IconCard
          primaryColor={tailwindColors.yellow[400]}
          secondaryColor={tailwindColors.yellow[100]}
          icon={<LayersIcon size={14} strokeWidth={1.5} absoluteStrokeWidth={true} />}
        >
          <CardValue title={issuer.selfRegulation.mandate} className="line-clamp-1">
            {issuer.selfRegulation.mandate}
          </CardValue>
          <CardDescription>
            <FormattedMessage
              defaultMessage="Mandato"
              id="zbwATS"
              description="Conteúdo dos cards para ativos do tipo FIIs"
            />
          </CardDescription>
        </IconCard>
      )}

      {issuer.selfRegulation.management && (
        <IconCard
          primaryColor={tailwindColors.blue[400]}
          secondaryColor={tailwindColors.blue[100]}
          icon={<CrownIcon size={14} strokeWidth={1.5} absoluteStrokeWidth={true} />}
        >
          <CardValue title={issuer.selfRegulation.management}>{issuer.selfRegulation.management}</CardValue>
          <CardDescription>
            <FormattedMessage
              defaultMessage="Gestão"
              id="LgXgN3"
              description="Conteúdo dos cards para ativos do tipo FIIs"
            />
          </CardDescription>
        </IconCard>
      )}

      {issuer.manager && (
        <IconCard
          primaryColor={tailwindColors.orange[400]}
          secondaryColor={tailwindColors.orange[100]}
          icon={<UserIcon size={14} strokeWidth={1.5} absoluteStrokeWidth={true} />}
        >
          <CardValue title={issuer.manager.name}>{issuer.manager.name}</CardValue>
          <CardDescription>
            <FormattedMessage
              defaultMessage="Gestor"
              id="CGqvRd"
              description="Conteúdo dos cards para ativos do tipo FIIs"
            />
          </CardDescription>
        </IconCard>
      )}
    </div>
  );
}
